import { makeVar, useReactiveVar } from "@apollo/client";
import config from "src/helpers/config";
import update from "immutability-helper";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import set from "lodash/set";
import { FunctionComponent } from "react";

interface StateValue {
    where: any;
    pagination: PaginationBookInput;
    reset?: boolean;
}

interface PaginationBookInput {
    limit: number;
    offset: number;
}

export const withStateAndActionsForBook = (Component: FunctionComponent) => {
    const WithComponent = (props: any) => {
        const { where } = props;
        const initialValue = {
            where: where,
            pagination: {
                limit: config.PAGINATION_LIMIT,
                offset: 0,
            },
        };
        const stateVar = makeVar(initialValue);
        const state = useReactiveVar(stateVar);

        function updateState({ where, pagination, reset = false }: StateValue) {
            const newState = update(
                state,
                reset
                    ? {
                          where: { $set: {} },
                          pagination: {
                              $set: {
                                  limit: config.PAGINATION_LIMIT,
                                  offset: 0,
                              },
                          },
                      }
                    : {
                          where: isEmpty(where)
                              ? { $set: where }
                              : {
                                    $merge: omit(where, "_and"),
                                    ...(where._and && {
                                        _and: {
                                            $set: where._and,
                                        },
                                    }),
                                },
                          pagination: { $merge: pagination },
                      },
            );

            stateVar(newState);
        }
        function onPaginationChange(pagination: PaginationBookInput) {
            updateState({ ...state, pagination });
        }
        function onStateReset() {
            updateState({ ...initialValue, reset: true });
        }

        function onNameChange(name: string) {
            const path = ["title", "_ilike"];
            const where = set({}, path, `%${name}%`);
            updateState({
                ...state,
                where,
                pagination: { ...state.pagination, offset: 0 },
            });
        }

        return (
            <Component
                {...{
                    // State
                    ...state,

                    // State Actions
                    onPaginationChange,
                    onStateReset,
                    onNameChange,
                }}
                {...props}
            />
        );
    };
    return WithComponent;
};

export default {
    read() {
        return stateVar();
    },
};
